module.exports = __webpack_public_path__ + "static/media/8H.1e9e59b0.png";